import React, { useEffect, useState } from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import VerticalLayout from './layout/vertical/Vertical';
import HorizontalLayout from './layout/horizontal/Horizontal';

import NotFound from './pages/sessions/404';
import { defaultRoutes, sessionRoutes, staticRoutes } from './routing';

import './App.scss';
import { useHideLoader } from './hooks/useHideLoader';
import StaticLayout from './layout/static/Static';

import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

const Routes = ({ routes, layout = '' }) => (
  <Switch>
    {routes.map((route, index) => (
      <Route
        key={index}
        exact={route.exact}
        path={layout.length > 0 ? `/${layout}/${route.path}` : `/${route.path}\``}
        component={() => <route.component />}
      />
    ))}

    <Route path='*'>
      <Redirect to='/public/page-404' />
    </Route>
  </Switch>
);

const DefaultRoutes = ({ layout }) => <Routes routes={defaultRoutes} layout={layout} />;

const SessionRoutes = () => <Routes routes={sessionRoutes} layout='public' />;

const StaticRoutes = () => <Routes routes={staticRoutes} layout='static' />;

const App = () => {

  // const [hubconnection, sethubconnection] = useState<HubConnection>();
  //
  // //context provider
  // useEffect(() => {
  //   createHubConnection();
  // }, []);
  //
  // const createHubConnection = async () => {
  //   const hubConnection = new HubConnectionBuilder().withUrl(`${process.env.REACT_APP_SIGNALR}`, {
  //     skipNegotiation: true,
  //     transport: HttpTransportType.WebSockets
  //   }).build();
  //   try {
  //     await hubConnection.start();
  //   } catch (e) {
  //     console.log('err', e);
  //   }
  //   // sethubconnection(hubConnection);
  // };

  useHideLoader();

  return (
    <Switch>
      <Route path='/' exact>
        <Redirect to='/public/sign-in' />
      </Route>

      <Route path='/public'>
        <SessionRoutes />
      </Route>

      <Route path='/static'>
        <StaticLayout>
          <StaticRoutes />
        </StaticLayout>
      </Route>

      <Route path='/horizontal'>
        <HorizontalLayout>
          <DefaultRoutes layout='horizontal' />
        </HorizontalLayout>
      </Route>

      <Route path='/vertical'>
        <VerticalLayout>
          <DefaultRoutes layout='vertical' />
        </VerticalLayout>
      </Route>

      <Route path='*'>
        <NotFound />
      </Route>
    </Switch>
  );
};

export default App;
